// ./src/contexts/MapElementsContext/MapElementsContext.tsx
//
// Thin context wrapper around the useEventMapElements hook. All derived data
// lives in the hook itself. See PointsOfInterestContext for the pattern.

import React, { createContext, useContext } from "react";

import {
  useEventMapElements,
  UseEventMapElementsOptions,
  UseEventMapElementsReturn,
} from "@/hooks/useEventMapElements";

const MapElementsContext = createContext<UseEventMapElementsReturn | null>(null);

export interface MapElementsProviderProps extends UseEventMapElementsOptions {
  children: React.ReactNode;
}

export const MapElementsProvider: React.FC<MapElementsProviderProps> = ({ children, ...options }) => {
  const value = useEventMapElements(options);

  return <MapElementsContext.Provider value={value}>{children}</MapElementsContext.Provider>;
};

export const useMapElementsContext = (): UseEventMapElementsReturn => {
  const context = useContext(MapElementsContext);

  if (!context) {
    throw new Error(
      "useMapElementsContext must be used within a <MapElementsProvider>. " +
        "Wrap your component tree with <MapElementsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalMapElementsContext = (): UseEventMapElementsReturn | null => {
  return useContext(MapElementsContext);
};
